export class AudioEngine {
    private context: AudioContext;
    private numberBuffers: Record<number, AudioBuffer> = {};
    private sfxBuffers: Record<string, AudioBuffer> = {};
    private isMuted: boolean = false;

    constructor() {
        this.context = new (window.AudioContext || (window as any).webkitAudioContext)();
    }

    async loadAll() {
        // Load sound effects
        await this.loadSFX("tap", "./tap.mp3");
        await this.loadSFX("success", "./success.mp3");
        await this.loadSFX("reject", "./reject.mp3");
        // Load number sounds (1 to 90)
        for (let i = 1; i <= 90; i++) {
            const res = await fetch(`./tambola/${i}.mp3`);
            const arrayBuffer = await res.arrayBuffer();
            this.numberBuffers[i] = await this.context.decodeAudioData(arrayBuffer);
        }
        await this.loadSFX("winner", "./winner.wav");
        await this.loadSFX("loser", "./loser.wav");
    }

    private async loadSFX(name: string, path: string) {
        const res = await fetch(path);
        const arrayBuffer = await res.arrayBuffer();
        this.sfxBuffers[name] = await this.context.decodeAudioData(arrayBuffer);
    }

    private async loadNumber(num: number): Promise<void> {
        if (this.numberBuffers[num]) return;

        const res = await fetch(`./tambola/${num}.mp3`);
        const arrayBuffer = await res.arrayBuffer();
        this.numberBuffers[num] = await this.context.decodeAudioData(arrayBuffer);
    }

    async play(num: number, muted = false) {
        if (this.isMuted || muted) return;

        if (!this.numberBuffers[num]) {
            try {
                await this.loadNumber(num);
            } catch (err) {
                console.error(`Failed to load number audio ${num}:`, err);
                return;
            }
        }

        const source = this.context.createBufferSource();
        source.buffer = this.numberBuffers[num];

        const gainNode = this.context.createGain();
        gainNode.gain.value = 1.0;

        source.connect(gainNode);
        gainNode.connect(this.context.destination);
        source.start(0);
    }

    playSFX(name: "success" | "reject" | "winner" | "loser" | "tap", muted = false) {
        if (this.isMuted || !this.sfxBuffers[name] || muted) return;

        const source = this.context.createBufferSource();
        source.buffer = this.sfxBuffers[name];

        const gainNode = this.context.createGain();
        gainNode.gain.value = 1.0; // Full volume

        source.connect(gainNode);
        gainNode.connect(this.context.destination);

        source.start(0);
    }


    mute(value: boolean) {
        this.isMuted = value;
    }

    unlock() {
        if (this.context.state === 'suspended') {
            this.context.resume();
        }
    }
}

export const audioEngine = new AudioEngine();
